module.exports = __webpack_public_path__ + "img/index-d2.087c5cfa.png";